import { medusaClient } from "./config";

export const fetchAllProducts = async (sort, limit = 12, offset = 0, collectionIds = [], categoryIds = []) => {
  // Use large page and paginate on client to ensure stable paging across backends
  const params = {
    limit: 99999,
    offset: 0,
  };
  if (sort === "latest") params["order"] = "-created_at";
  else if (sort?.includes("price")) params["description"] = sort;
  // else if (sort?.includes("popular")) {
  //   params["expand"] = "tags,variants,variants.prices,collection,categories";
  // }
  params["expand"] = "tags,variants,variants.prices,collection,categories";
  if (collectionIds?.length) params["collection_id"] = collectionIds;
  if (categoryIds?.length) params["category_id"] = categoryIds;
  const { products, count } = await medusaClient.products.list(params);
  if (!products.length) {
    throw new Error("Network response was not ok");
  }

  if (sort?.includes("popular")) {
    try {
      const sortedProducts = sortByFeaturedTag(products);
      const sorted = sortedProducts.slice(offset, offset + limit);
      return [sorted,count];
    } catch (err) {
      return [products.slice(offset, offset + limit),count];
    }

    // return sortedProducts.slice(offset, offset + limit);
  } else return [products.slice(offset, offset + limit),count];
};

export const fetchProducts = async (slug, sort, limit = 12, offset = 0, categoryIds = []) => {
  const { collections } = await medusaClient.collections.list({
    handle: [slug],
  });
  const collectionId = collections?.[0]?.id;
  if (!collectionId) return [[], 0];

  // Use large page and paginate on client for consistency
  const params = {
    limit: 99999,
    offset: 0,
    collection_id: [collectionId],
  };
  if (sort === "latest") params["order"] = "-created_at";
  else if (sort?.includes("price")) params["description"] = sort;
  // else if (sort?.includes("popular")) {
  //   params["expand"] = "tags,variants,variants.prices,collection,categories";
  // }
  params["expand"] = "tags,variants,variants.prices,collection,categories";
  if (categoryIds?.length) params["category_id"] = categoryIds;
  const { products, count } = await medusaClient.products.list(params);
  if (!products.length) return [[], count || 0];

  if (sort?.includes("popular")) {
    try {
      const sortedProducts = sortByFeaturedTag(products);
      const sorted = sortedProducts.slice(offset, offset + limit);
      return [sorted,count];
    } catch (err) {
      return [products.slice(offset, offset + limit),count];
    }

    // return sortedProducts.slice(offset, offset + limit);
  } else return [products.slice(offset, offset + limit),count];
};

function sortByFeaturedTag(products) {
  return products.sort((a, b) => {
    const hasFeaturedA = a.tags.some((t) => t.value === "featured");
    const hasFeaturedB = b.tags.some((t) => t.value === "featured");

    // Prioritize products with the "featured" tag
    if (hasFeaturedA && !hasFeaturedB) {
      return -1;
    } else if (!hasFeaturedA && hasFeaturedB) {
      return 1;
    } else {
      // If both have or neither have the "featured" tag, maintain original order
      return 0;
    }
  });
}
export const fetchCollections = async () => {
  const limit = 100;
  let offset = 0;
  let allCollections = [];
  let totalCount = Infinity;

  while (offset < totalCount) {
    const { collections, count } = await medusaClient.collections.list({
      limit,
      offset,
    });

    if (!collections?.length) {
      break;
    }

    allCollections = allCollections.concat(collections);
    totalCount = typeof count === "number" ? count : allCollections.length;
    offset += collections.length;
  }

  if (!allCollections.length) {
    throw new Error("Network response was not ok");
  }
  return allCollections;
};

export const fetchCategories = async () => {
  try {
    const res = await medusaClient.productCategories?.list({ limit: 99 });
    const list = res?.product_categories || res?.categories || [];
    return list;
  } catch (e) {
    // Some older SDKs expose categories under a different key
    try {
      const res2 = await medusaClient.categories?.list({ limit: 99 });
      return res2?.categories || [];
    } catch (err) {
      return [];
    }
  }
};

// Returns unique categories for a given collection handle
export const fetchCategoriesForCollectionHandle = async (handle) => {
  try {
    const { collections } = await medusaClient.collections.list({ handle: [handle] });
    const collectionId = collections?.[0]?.id;
    if (!collectionId) return [];
    // Fetch all products for this collection just to compute category coverage
    const { products } = await medusaClient.products.list({
      collection_id: [collectionId],
      expand: "categories",
      limit: 9999,
      offset: 0,
    });
    const map = new Map();
    (products || []).forEach((p) => {
      (p.categories || []).forEach((c) => {
        if (!map.has(c.id)) map.set(c.id, c);
      });
    });
    return Array.from(map.values());
  } catch (e) {
    return [];
  }
};
